export default function init() {
	// Turn off in IE 11. Even when polyfills for forEach() and includes() are added, 
	// this doesn't work, possibly because div.viewport is the scrollable wrapper instead of body or html (https://github.com/dirkgroenen/viewport-checker/issues/7)
	// @ts-ignore
	if (window.document.documentMode) {
		return;
	}
	
	// @ts-ignore
	const ViewportChecker = require('viewport-checker');

	function vpc(selector: string, offset: string = '20%') {
		const vpc = new ViewportChecker(selector, { 
			classToAdd: 'visible',
			classToAddForFullView: 'full-visible',
			classToRemove: 'invisible',
			removeClassAfterAnimation: false,
			offset: offset,
			invertBottomOffset: true,
			repeat: false,
			scrollBox: '.viewport'
		});
		document.addEventListener('DOMContentLoaded', () => {
			vpc.attach();
		});
	}
	vpc('.masthead');
	vpc('.nodeListing', '-20%');
	vpc('.richContent');
	vpc('.locations');
	vpc('.callToAction');
}